export { default } from './setRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/setRef/index.js
// module id = 445
// module chunks = 25